export default "__VITE_ASSET__DddPOVT3__"